import React, { useEffect, useState, ReactNode } from 'react'
import PropTypes from 'prop-types'

interface ThemeContextType {
  theme: string
  setTheme: (theme: string) => void
}

interface ThemeProviderProps {
  children: ReactNode
  name?: string
}

/**
 * @description Possible theme fonts: ptsans, default
 */
const ThemeContext = React.createContext<ThemeContextType>({
  theme: 'default',
  setTheme: () => {
    // Default empty function
  },
})

export function ThemeProvider({
  children,
  name = 'default',
}: ThemeProviderProps) {
  const [theme, setTheme] = useState(name)

  useEffect(() => {
    setTheme(() => {
      return name
    })
  }, [name])

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  )
}

ThemeProvider.propTypes = {
  children: PropTypes.any,
  name: PropTypes.string,
}

ThemeProvider.defaultProps = {
  name: 'default',
}

export default ThemeContext
